import Svg, { Path } from 'react-native-svg';
import { TIllustrationProps } from './types';

export function IllustrationSeedling({
  width = 60,
  height = 61,
  className,
}: TIllustrationProps) {
  return (
    <Svg
      width={width}
      height={height}
      className={className}
      fill="none"
      viewBox="0 0 60 61"
    >
      <Path
        fill="#71C9C4"
        fillRule="evenodd"
        d="M39.201 29.304a9.43 9.43 0 1 0-9.43-9.431v9.43H39.2Z"
        clipRule="evenodd"
      />
      <Path fill="#71C9C4" d="M39.222 19.81v-9.368h9.41v9.368z" />
      <Path
        fill="#71C9C4"
        fillRule="evenodd"
        d="M39.201 50.108a9.43 9.43 0 1 0-9.43-9.43v9.43H39.2Z"
        clipRule="evenodd"
      />
      <Path fill="#71C9C4" d="M39.222 40.615v-9.368h9.41v9.368z" />
      <Path
        fill="#71C9C4"
        fillRule="evenodd"
        d="M20.472 60.625a9.43 9.43 0 1 1 9.43-9.431v9.43H20.473Z"
        clipRule="evenodd"
      />
      <Path fill="#71C9C4" d="M20.451 51.131v-9.368h-9.41v9.368z" />
      <Path
        fill="#FF8D78"
        fillRule="evenodd"
        d="M20.34 19.487a9.43 9.43 0 1 1 9.43-9.431v9.43h-9.43Z"
        clipRule="evenodd"
      />
      <Path fill="#FF8D78" d="M20.319 9.993V.625h-9.41v9.368z" />
      <Path fill="#71C9C4" d="M29.771 19.487h3.332v41.138h-3.332z" />
    </Svg>
  );
}
